import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSnowNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M8.625 0v2.083l1.667-1.25.75 1-2.417 1.813v3.272l2.834-1.636.36-3 1.242.15-.25 2.069 1.805-1.042.625 1.082-1.804 1.042 1.916.818-.491 1.15-2.778-1.187L9.25 8l2.833 1.636 2.778-1.187.491 1.15-1.915.818 1.804 1.042-.625 1.082-1.804-1.041.249 2.068-1.241.15-.362-3-2.833-1.636v3.272l2.417 1.813-.75 1-1.667-1.25V16h-1.25v-2.083l-1.667 1.25-.75-1 2.417-1.813V9.083l-2.833 1.636-.361 2.999-1.242-.15.25-2.068-1.804 1.041L.76 11.46l1.804-1.042L.648 9.6l.49-1.15 2.779 1.187L6.75 8 3.917 6.364 1.139 7.551.648 6.4l1.916-.818L.759 4.54l.625-1.082L3.19 4.5l-.25-2.068 1.241-.15.362 3 2.833 1.635V3.646L4.958 1.833l.75-1 1.667 1.25V0z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSnowNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSnowNormalXsmall;
